import Header30 from './Header30'
export default Header30
